/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type GetOrdersOrder = typeof GetOrdersOrder[keyof typeof GetOrdersOrder];


export const GetOrdersOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
